import React, { Component } from 'react';
import AddData from './components/AddData/AddData';
import Map from './components/Map/Map';
import BasemapSwitcher from './components/BasemapSwitcher/BasemapSwitcher';
import mapOptions from './util/mockMapOptions';
import ElementsProvider from './components/_common/ElementsProvider';
import ScaleBar from './components/ScaleBar/ScaleBar'
import Draw from './components/Draw/Draw'
import { loadBookmarks,  deleteBookmark, saveBookmark, goToBookmark } from './components/Bookmarks/util/bookmarkActions';
import Bookmarks from './components/Bookmarks/Bookmarks';
import Sidebar from './sidebar';
import MapInfo from './components/MapInfo/MapInfo'
import LayerList from './components/LayerList/LayerList';
import Zoom from './components/Zoom/Zoom';
import Home from './components/Home/Home'

class App extends Component {

  render(){

    return (
      <ElementsProvider>
      <Map mapOptions={mapOptions}>
        <Sidebar />
      <AddData/>
        <BasemapSwitcher sx={{marginTop:'380px'}}/>
        <ScaleBar/>
        <Draw />

        <Bookmarks 
        baseType={'button'}
        goToBookmark={goToBookmark}
        loadBookmarks={loadBookmarks}
        deleteBookmark={deleteBookmark}
        saveBookmark={saveBookmark}
        />
   <LayerList
      sx={{marginTop: '420px'}}
        panel={true}
        layers={[
          {
            layerIds: ['admin-0-boundary', 'admin-0-boundary-bg'], //line
            layerName: 'Admin 0 boundaries'
          },
          {
            layerIds: ['admin-1-boundary', 'admin-1-boundary-bg'], //line
            layerName: 'Admin 1 boundaries'
          },
          {
            layerIds: ['admin-2-boundary'], //line
            layerName: 'Admin 2 boundaries'
          },
          {
            layerIds: ['admin-3-boundary'], //line
            layerName: 'Admin 3 boundaries'
          },
        ]}
      >
        </LayerList>
        <MapInfo 
        baseType={'button'}
        sx={{
        position: 'fixed',
        left: 450,
        top: 47,
        fontSize: '12px',
        backgroundColor: 'white',
        cursor: 'pointer',
        zIndex: '3'
        }}/>
        <Zoom 
        showZoomLevel={true}
        sx={{
          position: 'fixed',
        right: 2,
        top: 10,
        }}/>
      </Map>
      <Home 
      sx={{
        position: 'fixed',
        left: 450,
        top: 85,
        backgroundColor: 'blue'
      }}
      />
      </ElementsProvider>
    );
  }
}
export default App;

// export default function App() {
// const mapContainer = useRef(null);
// const map = useRef(null);
// const [lng, setLng] = useState(-70.9);
// const [lat, setLat] = useState(42.35);
// const [zoom, setZoom] = useState(9);
 
// useEffect(() => {
// if (map.current) return; // initialize map only once
// map.current = new mapboxgl.Map({
// container: mapContainer.current,
// style: 'mapbox://styles/mapbox/streets-v11',
// center: [lng, lat],
// zoom: zoom
// });
// });
 
// useEffect(() => {
// if (!map.current) return; // wait for map to initialize
// map.current.on('move', () => {
// setLng(map.current.getCenter().lng.toFixed(4));
// setLat(map.current.getCenter().lat.toFixed(4));
// setZoom(map.current.getZoom().toFixed(2));
// });
// });


// return (
// <div>
// <div className="sidebar">
// Longitude: {lng} | Latitude: {lat} | Zoom: {zoom}
// </div>
// <div ref={mapContainer} className="map-container" />
// </div>
// );
// }